import debounce from "lodash/debounce";
import { computed, reactive, ref } from "vue";
import { messages } from "./chatState";
import { ws_instance } from "../websocket/ws-instance";
import { authState } from "./auth";

interface messageInfo {
  remoteId?: string;
  localId?: string;
}

const lastSendReadMark = reactive({
  id: "",
  date: Date.now(),
});

export function setlastSendReadMark(mark: { messageId: string; at: string }) {
  lastSendReadMark.id = mark.messageId;
  const date = new Date(mark.at);
  lastSendReadMark.date = date.getTime();
}

const localMessagesMarks = new Set();
const remoteMessagesMarks = new Set();
const lastRead = ref("");

export function setReadMark(info: messageInfo) {
  if (info.remoteId) {
    remoteMessagesMarks.add(info.remoteId);
    const last = messages[messages.length - 1];
    if (last.id === info.remoteId) {
      flushOne({ id: last.id, createAtDate: last.createAtDate });
    }
  } else if (info.localId) localMessagesMarks.add(info.localId);
  lastRead.value = info.localId || info.remoteId || "";
  debouncedFlush();
}

function flushOne(last: { id: string; createAtDate: Date }) {
  localMessagesMarks.clear();
  remoteMessagesMarks.clear();
  ws_instance.api_message("read-mark", {
    id: last.id,
  });
  lastSendReadMark.id = last.id;
  lastSendReadMark.date = last.createAtDate.getTime();
}

async function flushReadMark() {
  const local = Array.from(localMessagesMarks).filter((m) => !!m);
  const remote = Array.from(remoteMessagesMarks).filter((m) => !!m);
  localMessagesMarks.clear();
  remoteMessagesMarks.clear();
  const localMessages = messages.filter((m) => local.includes(m.local?.id));
  const remoteMessages = messages.filter((m) => remote.includes(m.id));
  const allMessages = [...localMessages, ...remoteMessages].sort(
    (a, b) => a.createAtDate.getTime() - b.createAtDate.getTime(),
  );
  const last = allMessages.pop();
  if (last) {
    if (last.id) {
      if (
        (lastSendReadMark.id &&
          last.createAtDate.getTime() > lastSendReadMark.date) ||
        !lastSendReadMark.id
      ) {
        ws_instance.api_message("read-mark", {
          id: last.id,
        });
        lastSendReadMark.id = last.id;
        lastSendReadMark.date = last.createAtDate.getTime();
      }
    } else {
      //wait remote id
      //send mark
    }
  }
}

const debouncedFlush = debounce(flushReadMark, 5000);

export const isNewMessages = computed(() => {
  const isLastRead = lastRead.value;
  const messagesLength = messages.length > 0;
  if (isLastRead || messagesLength) {
    const lastmessage = messages[messages.length - 1];
    if(!lastmessage) return false
    if (remoteMessagesMarks.has(lastmessage.id)) {
      return false;
    } else if (localMessagesMarks.has(lastmessage.local?.id)) {
      return false;
    } else if (lastSendReadMark.id === lastmessage.id) {
      return false;
    } else if(lastmessage.author.id === authState.id) {
      return false;
    } else return true;
  } else {
    return false;
  }
});

export const readMarkViewState = reactive({
  show: false,
  messageId: "",
});

export function freezeLastRead() {
  if (isNewMessages.value) {
    readMarkViewState.show = true;
    readMarkViewState.messageId = lastSendReadMark.id;
  } else {
    readMarkViewState.show = false;
    readMarkViewState.messageId = "";
  }
}

export const readMarkEl = ref<HTMLElement | null>(null);
